<template>
  <div>
    <div style="padding-top: 50px"></div>

    <van-row justify="space-between">
      <van-col span="24">
        <van-field name="radio" label="用户类型">
          <template #input>
            <van-radio-group v-model="yhlx" direction="horizontal">
              <van-radio name="t" v-if="mnjsqx">教师</van-radio>
              <van-radio name="s" v-if="mnxsqx">学生</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-col>
      <van-col span="24" style="height: 60px" >
        <van-search
          v-model="bhxm"
          placeholder="请输入账号或姓名查询"
          @search="getlist"
          show-action
        >
        <template #action>
          <div @click="getlist">搜索</div>
        </template>
        </van-search>
      </van-col>
    </van-row>

    <van-loading type="spinner" style="text-align: center" color="#1989fa" v-if="loading" />
    <van-empty v-if="showdata" description="暂无数据" />

    <van-row v-for="(item,index) in yhlist" :key="'rowyh'+index" justify="space-between">
      <van-col span="24" @click="clickmndl(item)">
        <van-cell class="cellyh" is-link >
          <template #title>
            <span style="font-size: 16px">
                {{item.xm}}
              </span><br>
            <span style="color:#C0C0C0">账号:{{item.bh}}</span><br>
            <span style="color:#C0C0C0">院系:{{item.dw}}</span>
          </template>
        </van-cell>
      </van-col>
    </van-row>
  </div>
</template>

<script>
  import {Dialog, Notify} from "vant";
  import {encrypt} from "../../utils/jsencrypt";

    export default {
        name: "mndlindex",
      props: {
        mnxsqx: {
          type: Boolean,
          default: null
        },
        mnjsqx: {
          type: Boolean,
          default: null
        },
      },
      data() {
        return {
          loading: false,
          showdata: false,

          yhlist:[],
          yhlx:null,
          bhxm:null,

          yusername:null,
          yaccount:null,
        }
      },
      created() {
        if(this.mnjsqx){
          this.yhlx = 't'
        }
        if(this.mnxsqx){
          this.yhlx = 's'
        }
      },
      methods: {
        getlist() {
          if(this.yhlx == null){
            Notify({ type: 'danger', message: '请选择用户类型' });
            return;
          }
          this.loading = true;
          let that = this;
          let datas = {
            yhlx: this.yhlx,
            bhxm: this.bhxm,
          };
          this.$ajax.post('/appapi/getmndl', datas).then(function (rep) {
            if (rep.code === 200) {
              that.yhlist = rep.yhlist;
              that.yusername = rep.yusername;
              if (that.yhlist.length > 0) {
                that.showdata = false;
              } else {
                that.showdata = true;
              }
            }
            that.loading = false;
          });
        },
        clickmndl(item){
          Dialog.confirm({
            title: '提示',
            message: '确定用 ('+item.bh+')'+item.xm+' 模拟登陆吗？',
          })
            .then(() => {
              this.login(item.bh);
            })
            .catch(() => {
            });
        },
        async login(username) {
          const queryParams = {
            username: username,
            code:this.yusername,
          };
          const res = await this.$ajax.post('/appapi/apploginmndl',queryParams);
          if (res.code == 200) {
            localStorage.clear();
            let user = res.user;
            localStorage.setItem('Token', res.user.token);
            localStorage.setItem('Identity', user.usertype);
            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('jxsysxy', '1');
            localStorage.setItem("weakPass",res.weakPass)
            this.$router.push('/work');
            //location.href = this.$global.assetsPublicPath+'/work';
          }
        },
      }
    }
</script>

<style scoped>
  .cellyh{
    height: 80px;
    padding: 5px 5px 5px 20px;
    margin: 5px 0px 5px 0px;
    border-bottom: 1px solid #e4e4e4;
  }
</style>



// WEBPACK FOOTER //
// src/views/Mine/mndlindex.vue